class Coments {
  constructor(comentId, codAplica, comentario) {
    this.comentId = comentId;
    this.codAplica = codAplica;
    this.comentario = comentario;
    this.subtitle = this.getType(codAplica);
    this.name = comentario;
  }
  getType(type) {
    switch (type) {
      case 1:
        return "Auditoría";
      case 2:
        return "Autorización";
      default:
        return type;
    }
  }
  static fromJson({ comentId, codAplica, comentario}) {
    return new Coments(comentId, codAplica, comentario);
  }
}

export default Coments;
